import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BreadcrumbsComponentDef } from '@df/ui/common/breadcrumbs.component.def';

/**
 * Breadcrumbs component
 *
 * ## usage
 *
 * <breadcrumbs></breadcrumbs>
 */
@Component({
    selector: 'breadcrumbs',
    templateUrl: './breadcrumbs.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent extends BreadcrumbsComponentDef {
    @Input()
    variant?: 'default' | 'light' = 'default';

    protected getCrumbClass(lastElement, crumb): string {
        if (this.variant === 'default') {
            return lastElement && this.isSelfLocation(crumb) ? 'col-51' : 'col-12';
        } else {
            return lastElement && this.isSelfLocation(crumb) ? 'col-11' : 'col-4';
        }
    }
}
